// Constants
import { EvoBrand, PlannerTheme } from "@ms/uno-constants/lib/local/ThemeConstants";
// Utilities
import { createDarkTheme, createHighContrastTheme, createLightTheme } from "@fluentui/react-components";
/** Light theme for Evo as derived from design's brand variant colors */ const evoLightTheme = createLightTheme(EvoBrand);
/** Dark theme for Evo as derived from design's brand variant colors */ const evoDarkTheme = createDarkTheme(EvoBrand);
/** High contrast theme for FluentUI V9, for use in the Copilot pane */ const highContrastTheme = createHighContrastTheme();
/**
 * Creates and loads the v9 theme for the FluentProvider, based on the provided Evo theme
 * @param theme The Planner theme
 */ export const getV9Theme = (theme)=>{
    switch(theme){
        case PlannerTheme.Dark:
            return evoDarkTheme;
        case PlannerTheme.HighContrast:
            return highContrastTheme;
        case PlannerTheme.Light:
        default:
            return evoLightTheme;
    }
};
